module.exports = __webpack_public_path__ + "img/instagram-brands-solid-full.29e6fd40.svg";